// This is Careers Register base component from where login, signup and otp verifications screens are maintained.

// imports
import React, { useState, useEffect, useLayoutEffect, use } from "react";
import "../../assets/css/register/register.css";
import "./GoogleSignIn/style.css";
import CareersRegisterLeft from "../registration/CareersRegisterLeft";
import CareersRegisterRight from "../registration/CareersRegisterRight";
import { domains } from "../../constants/registration";
import ReactGA from "react-ga";
import Cookies from "universal-cookie";
import { createCurrentUrl, certificationPage, getAbsoluteDestinationUrl, IdsCheck, isLoginPage, isSignupPage, setCookiesAndRedirectionOnLogin} from "../../utils/registrationUtils"
import { connect, useSelector,useDispatch } from "react-redux";
import {
  postUserProfileClevertap, getOneClickLoginUserCheck
} from "../../../store/slices/Registration/CommonSlices";
import { gaEvent, gaLocationAndContentData } from "../../utils/index";
import Loading from "../utils/loader";
import axios from "axios";
import {postUserPushToLSQ} from "../../../store/slices/user"

const CareersRegister = (props) => {
  const dispatch = useDispatch();
  //-----------Local States------------------
  const [domain, setDomain] = useState(null);
  const { googleSigninData: googleSigninDatas } = useSelector((state) => state.usersGoogleSiginIn);
  const { oneClickLoginUserCheck : oneClickLoginUserChecks, oneClickLoginUserCheckError } = useSelector((state) => state.usersCommonData);

  // ----------Local variables----------------

  //cookies data 
  const cookies = new Cookies();
  const loginDataCookies = cookies?.get("loginState");
  const signupDataCookies = cookies.get("registrationState");
  const oneClickUuid = cookies?.get("one-click-login")?.data?.uuid;
  const userUuid = oneClickUuid ? oneClickUuid : loginDataCookies?.userUuid;
  const googleUserUuid = loginDataCookies?.user_uuid;
  let searchParams = window.location.search; 
  const oneClickLocation = new URLSearchParams(searchParams)?.get("isOneClickVerify");

  let date = new Date(); // Get current date
  //to check current url
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;

  // to check the page is for certification domain
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);

  // geting the current url from cookies added from the source url
  const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const urlObj = currentUrl ? new URL(currentUrl) : null;
  const cleanUrl =urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
  // geting the sourse destination
  const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
  
  //getting destinationDomain for cookies domain
  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;

  // -------------UseEffects-----------------------

  // setting subdomain for opening registration form for respective of subdomain.
  useEffect(() => {
    if (isSignupPage || isLoginPage) {
      gaEvent("onload", "login_signup", `${gaLocationAndContentData}`, "");
    }
    let domainVal;

    // Check if the current hostname includes "localhost"
    if (window.location?.hostname?.includes("localhost")) {
      // If on localhost, extract the "domain" parameter from the URL query params
      const urlParams = new URLSearchParams(window.location.search);
      domainVal = urlParams?.get("domain");
    }
    // Check if either certificationFormCheck is true or certificationPage(urlCheck) returns true, if true set somain value to certification.
    else if (certificationFormCheck || certificationPage(urlCheck)) {
      domainVal = "certification";
    }
    // Otherwise, extract the subdomain from the hostname
    else {
      domainVal = window.location.host?.split(".")[0];
    }

    let domainObj = {};
    // Find the domain object in the domains array that matches domainVal
    domainObj = domains.find((obj) => obj.name == domainVal);

    // If no matching domain object is found, default to the domain object with name "www"
    if (!domainObj) {
      domainObj = domains.find((obj) => obj.name == "www");
    }
    setDomain(domainObj);
    // One Click login user check api call
    if(oneClickLocation != "true" && (googleUserUuid || userUuid)){
    let params = {};
    params.user_uuid = userUuid ? userUuid : googleUserUuid;
    props.dispatch(getOneClickLoginUserCheck(params));
    }
  }, []);

  // login access cookies added for successful login of user.
  useEffect(() => {
    // Check if login has proceeded and updating profile is not required
    if (props.loginDatas?.proceed == true && props.loginDatas?.ask_update_profile == false) {
      // Post CleverTap events
      clevertapEvents();
      // If the current pathname does not include "user/login/otp-verify", post CleverTap user profile data
      if (!window.location.pathname?.includes("user/login/otp-verify")) {
        postUserProfileClevertapData("signUp");
      }
      // if (props.loginDatas?.uid) {
      //   dispatch(postUserPushToLSQ({ user_id: props.loginDatas?.uid }));
      // }
      // setCookiesAndRedirectionOnLogin(props.loginDatas);
      setCookiesAndRedirectionOnLogin(props.loginDatas, () =>
      dispatch(postUserPushToLSQ({ user_id: props.loginDatas?.uid }))
    );

    }
    if (googleSigninDatas?.proceed == true && googleSigninDatas?.ask_update_profile == false && googleSigninDatas?.ask_complete_profile == false) {
      gaEvent("sessioncontinuewithgoogle", "login_signup", `${gaLocationAndContentData}`, ""); // on successful session start via google signin
      clevertapEvents("google");
      postUserProfileClevertapData("google");
      // if (googleSigninDatas?.user_id) {
      //   dispatch(postUserPushToLSQ({ user_id: googleSigninDatas?.user_id }));
      // }
      // setCookiesAndRedirectionOnLogin(googleSigninDatas);
      setCookiesAndRedirectionOnLogin(googleSigninDatas, () =>
      dispatch(postUserPushToLSQ({ user_id: googleSigninDatas?.user_id }))
    );
    }
  }, [props.loginDatas, googleSigninDatas])
  // Redirection to complete profile in case of one click login
  useEffect(() => {
    if(oneClickLoginUserChecks && oneClickLoginUserChecks?.ask_complete_profile && (googleUserUuid || userUuid)){
        const uuidToSet = userUuid || googleUserUuid;
        const uuidKey = userUuid ? "userUuid" : "user_uuid";
        cookies.set("loginState", { [uuidKey]: uuidToSet, user_type: "new_user", ask_mobile_verify : oneClickLoginUserChecks?.ask_mobile_verify, cta_clicked : "one_click" }, {
        path: "/",
        expires: new Date(date.setDate(date.getDate() + 3)),
        sameSite: "Lax",
        domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
    });
    sessionStorage.setItem("loginState", JSON.stringify({ [uuidKey]: uuidToSet, user_type: "new_user", ask_mobile_verify : oneClickLoginUserChecks?.ask_mobile_verify, cta_clicked : "one_click" }));
    window.location.href = `/user/complete-profile${window.location.search}`;
    }
  },[oneClickLoginUserChecks])

  useEffect(() => {
        if(oneClickLoginUserCheckError){
            cookies.remove("one-click-login", {
                path: "/",
                domain: destinationDomain,
              });
              cookies.remove("mv_status", {
                path: "/",
                domain: destinationDomain,
              });
              cookies.remove("up_status", {
                path: "/",
                domain: destinationDomain,
              });
              cookies.remove("loginState", {
                path: "/",
                domain: destinationDomain,
              })
              cookies.remove("user-agent-key", {
                path: "/",
                domain: destinationDomain,
              });
              sessionStorage.clear(); 
              // window.location.href = cleanUrl || getAbsoluteDestinationUrl();
        }
      }, [oneClickLoginUserCheckError])

  // -----------Local Functions --------------------

  // for clevertap user-profile post api where all fileds data is needed
  const postUserProfileClevertapData = (type) => {
    if(type == "signUp"){
    // Retrieve signup data from cookies
    const signupData = cookies.get("registrationState")?.formValues;
    let obj = {};
    obj.current_url = window.location.href;
    obj.page_url = sourseDestination;
    obj.cta_clicked = "signup";
    obj.country_code = "+91";
    obj.mobile_number = signupData?.mobile;
    obj.location = signupData?.location?.id;
    obj.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
    obj.email = signupData?.email;
    obj.education_level = signupData?.education_level?.id;
    obj.name = signupData?.studentname?.trim();
    obj.interested_in = signupData.interested_in?.length > 0 ? IdsCheck(signupData?.interested_in) : [];
    obj.checkbox_id = props.tertiaryChecboxData?.id ?? 0;
    obj.checkbox_status = signupData?.tertiary_checkbox?.[0]?.id == 1 ? true : false;
    if (cookies.get("registrationState")?.postSignupData?.user_uuid) { // check if userUuid exists or send the updated one.
      obj.user_uuid = cookies.get("registrationState")?.postSignupData?.user_uuid;
    }
    if (signupData?.passing_year)
      obj.passing_year = signupData?.passing_year?.id;
    if (signupData?.aspiring_stream)
      obj.aspiring_stream = signupData?.aspiring_stream?.id;
    if (signupData?.degree_pursue)
      obj.degree_pursue = signupData.degree_pursue?.id;
    if (signupData?.target_year)
      obj.target_year = signupData.target_year?.id;
    if (signupData?.work_experience)
      obj.work_experience = JSON.stringify(signupData.work_experience?.id);
    if (signupData?.education_interest) {
      if (signupData?.education_interest?.id)
        obj.degree_interested = signupData?.education_interest?.id
      if (signupData?.education_interest?.group_id) {
        obj.is_group = true;
      }
      obj.domain_id = signupData?.education_interest?.domain_id;
    };
    if (signupData.passport?.length > 0)
      obj.passport = signupData.passport?.[0]?.id;
    if (signupData.course_joining_preference)
      obj.course_joining_preference = signupData?.course_joining_preference?.[0]?.id;
    if (signupData.area_of_interest?.length > 0)
      obj.area_of_interest = signupData?.area_of_interest;
    if (signupData?.country?.length > 0)
      obj.country = IdsCheck(signupData?.country);
    if (signupData.certificate_interest)
      obj.certificate_interest = signupData.certificate_interest?.domain_id;
    //certification domain based param.
    obj.certification = props.domain?.id == 2 ? true : false;
    props.dispatch(postUserProfileClevertap(obj));
  }else {
      let params = {};
      params.current_url = window.location.href;
      params.page_url = sourseDestination;
      params.destination = getAbsoluteDestinationUrl();
      params.cta_clicked = "google";
      params.certification = domain?.id == 2 ? true : false;
      params.user_id = googleSigninDatas?.user_id;
      if(googleSigninDatas?.email){
        params.email = googleSigninDatas?.email;
      }
      props.dispatch(postUserProfileClevertap(params));
    }
  };

  // Clevertap Events
  const clevertapEvents = (type) => {
    if(type == "google"){
      let clevertapEventsData = {};
      if (googleSigninDatas?.email) clevertapEventsData.userEmail = googleSigninDatas?.email;
      window?.dataLayer?.push({ ...clevertapEventsData, event: "ctlogin" });
    }
    if(type != "google"){
    if (!window.location.pathname?.includes("user/otp-verify")) { // this check is added tha events should only trigger on login page.
      let clevertapEventsData = {};
      clevertapEventsData.userMobile = loginDataCookies?.formValues?.mobile;
      if (loginDataCookies?.formValues?.email) clevertapEventsData.userEmail = loginDataCookies?.formValues?.email;
      window?.dataLayer?.push({ ...clevertapEventsData, event: "ctlogin" });
      gaEvent("sessionsignup", "login_signup", `${gaLocationAndContentData}`, "");
      if (loginDataCookies?.formValues?.email) {
        gaEvent("otpemailverifysignin", "login_signup", `${gaLocationAndContentData}`, "");
      }
      if (loginDataCookies?.email_field_visibility == false) {
        gaEvent("otpmobileverifysignin", "login_signup", `${gaLocationAndContentData}`, "");
      }
    }
    if (!window.location.pathname?.includes("user/login/otp-verify")) { // this check is added tha events should only trigger on signup via OTP verification page.
      if (cookies.get("registrationState")?.currentScreen?.screen == 3) { // for email verify
        gaEvent("otpemailverifysignup", "login_signup", `${gaLocationAndContentData}`, "");
      }
      if (cookies.get("registrationState")?.currentScreen?.screen == 2) { //for mobile verify
        gaEvent("otpmobileverifysignup", "login_signup", `${gaLocationAndContentData}`, "");
      }
      gaEvent("sessionsignin", "login_signup", `${gaLocationAndContentData}`, ""); // on sucessful session start
      if (props.loginDatas?.user_type == "new_user") { // trigger only in case of new user
        let clevertapEventsDataSignup = {};
        clevertapEventsDataSignup.userName = signupDataCookies?.formValues?.studentname;
        clevertapEventsDataSignup.userEmail = signupDataCookies?.formValues?.email;
        clevertapEventsDataSignup.userMobile = signupDataCookies?.formValues?.mobile;
        clevertapEventsDataSignup.studyingIn = signupDataCookies?.formValues?.education_level?.label;
        clevertapEventsDataSignup.userLocation = signupDataCookies?.formValues?.location?.label;
        if (signupDataCookies?.formValues?.education_interest || signupDataCookies?.formValues?.certificate_interest)
          clevertapEventsDataSignup.eduInterest = signupDataCookies?.formValues?.education_interest?.label || signupDataCookies?.formValues?.certificate_interest?.label;
        if (signupDataCookies?.formValues?.target_year)
          clevertapEventsDataSignup.admissionTarget = signupDataCookies?.formValues?.target_year?.label;
        if (signupDataCookies?.formValues?.passing_year) clevertapEventsDataSignup.passingYear = signupDataCookies?.formValues?.passing_year?.label;
        window?.dataLayer?.push({ ...clevertapEventsDataSignup, event: "ctsignup" });
      } else {   // trigger in case of existing user(either existing email or mobile or both).
        let clevertapEventsData = {};
        clevertapEventsData.userMobile = signupDataCookies?.formValues?.mobile;
        clevertapEventsData.userEmail = signupDataCookies?.formValues?.email;
        window?.dataLayer?.push({ ...clevertapEventsData, event: "ctlogin" });
      }
    }
  }

  }

  return (
    <div className="careers_register_main">
      {domain &&
        <>
          {/* Added if user is logged in then show loader else be on same page(Registration pages). */}
          {((props.loginDatas?.proceed && props.loginDatas?.ask_update_profile == false) || (googleSigninDatas?.proceed == true
            && googleSigninDatas?.ask_update_profile == false && googleSigninDatas?.ask_complete_profile == false)) ?
            // loader
            <div className="text-center">
              <Loading colour={"FFA500"} size={100} />
            </div>
            :
            //Left side content page.
            <><div className="careers_register_leftside">
              <CareersRegisterLeft />
            </div>
              {/* Right side Content page where all forms screens are visible accordingly */}
              <div id="manage_dropdown_leftshift" tabIndex="0" className="careers_register_rightside">
                <CareersRegisterRight screen="otp_verify" domain={domain} />
              </div></>}
        </>}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    userIps: state.usersCommonData?.userIp,
    userIpError: state.usersCommonData?.userIpError,
    loginDatas: state.usersCommonData?.loginData,
    postSignupData: state.userSignUpFields?.signupData,
    geolocationData: state.usersCommonData?.geoLocation,
    googleSigninCheck: state.usersCommonData?.googleSigninCheckData
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegister);
